"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanRange = exports.defaultRange = exports.pickerOptions = exports.time = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
exports.time = {
    startOfTomorrow: moment_1.default().add(1, 'day').startOf('day'),
    endOfTomorrow: moment_1.default().add(1, 'day').endOf('day'),
    startOfToday: moment_1.default().startOf('day'),
    endOfToday: moment_1.default().endOf('day'),
    startOfYesterday: moment_1.default().subtract(1, 'day').startOf('day'),
    endOfYesterday: moment_1.default().subtract(1, 'day').endOf('day'),
    startOfNextWeek: moment_1.default().add(1, 'week').startOf('isoWeek'),
    endOfNextWeek: moment_1.default().add(1, 'week').endOf('isoWeek'),
    startOfWeek: moment_1.default().startOf('isoWeek'),
    endOfWeek: moment_1.default().endOf('isoWeek'),
    startOfLastWeek: moment_1.default().subtract(1, 'week').startOf('isoWeek'),
    endOfLastWeek: moment_1.default().subtract(1, 'week').endOf('isoWeek'),
    startOfNextMonth: moment_1.default().add(1, 'month').startOf('month'),
    endOfNextMonth: moment_1.default().add(1, 'month').endOf('month'),
    startOfMonth: moment_1.default().startOf('month'),
    endOfMonth: moment_1.default().endOf('month'),
    startOfLastMonth: moment_1.default().subtract(1, 'month').startOf('month'),
    endOfLastMonth: moment_1.default().subtract(1, 'month').endOf('month'),
    startOfNextYear: moment_1.default().add(1, 'year').startOf('year'),
    endOfNextYear: moment_1.default().add(1, 'year').endOf('year'),
    startOfYear: moment_1.default().startOf('year'),
    endOfYear: moment_1.default().endOf('year'),
    startOfLastYear: moment_1.default().subtract(1, 'year').startOf('year'),
    endOfLastYear: moment_1.default().subtract(1, 'year').endOf('year'),
};
exports.pickerOptions = {
    firstDayOfWeek: 1,
    shortcuts: [{
            text: 'Today',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfToday, exports.time.endOfToday]);
            },
        }, {
            text: 'Yesterday',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfYesterday, exports.time.endOfYesterday]);
            },
        }, {
            text: 'This Week',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfWeek, exports.time.endOfWeek]);
            },
        }, {
            text: 'Last Week',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfLastWeek, exports.time.endOfLastWeek]);
            },
        }, {
            text: 'This Month',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfMonth, exports.time.endOfMonth]);
            },
        }, {
            text: 'Last Month',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfLastMonth, exports.time.endOfLastMonth]);
            },
        }, {
            text: 'This Year',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfYear, exports.time.endOfYear]);
            },
        }, {
            text: 'Last year',
            onClick(picker) {
                picker.$emit('pick', [exports.time.startOfLastYear, exports.time.endOfLastYear]);
            },
        }],
};
exports.defaultRange = [
    moment_1.default().startOf('day'),
    moment_1.default().endOf('day'),
];
function humanRange(dateRange = exports.defaultRange) {
    const start = moment_1.default(dateRange[0]).startOf('day');
    const end = moment_1.default(dateRange[1]).endOf('day');
    if (start.isSame(exports.time.startOfTomorrow) && end.isSame(exports.time.endOfTomorrow)) {
        return 'Tomorrow';
    }
    if (start.isSame(exports.time.startOfToday) && end.isSame(exports.time.endOfToday)) {
        return 'Today';
    }
    if (start.isSame(exports.time.startOfYesterday) && end.isSame(exports.time.endOfYesterday)) {
        return 'Yesterday';
    }
    if (start.isSame(exports.time.startOfNextWeek) && end.isSame(exports.time.endOfNextWeek)) {
        return 'Next Week';
    }
    if (start.isSame(exports.time.startOfWeek) && end.isSame(exports.time.endOfWeek)) {
        return 'This Week';
    }
    if (start.isSame(exports.time.startOfLastWeek) && end.isSame(exports.time.endOfLastWeek)) {
        return 'Last Week';
    }
    if (start.isSame(exports.time.startOfNextMonth) && end.isSame(exports.time.endOfNextMonth)) {
        return 'Next Month';
    }
    if (start.isSame(exports.time.startOfMonth) && end.isSame(exports.time.endOfMonth)) {
        return 'This Month';
    }
    if (start.isSame(exports.time.startOfLastMonth) && end.isSame(exports.time.endOfLastMonth)) {
        return 'Last Month';
    }
    if (start.isSame(exports.time.startOfNextYear) && end.isSame(exports.time.endOfNextYear)) {
        return 'Next Year';
    }
    if (start.isSame(exports.time.startOfYear) && end.isSame(exports.time.endOfYear)) {
        return 'This Year';
    }
    if (start.isSame(exports.time.startOfLastYear) && end.isSame(exports.time.endOfLastYear)) {
        return 'Last Year';
    }
    const suffix = moment_1.default().isSame(start, 'year') ? '' : ' YY';
    const sameDays = start.isSame(end, 'day');
    if (sameDays) {
        return `${end.format(`D MMM${suffix}`)}`;
    }
    if (start.isSame(end, 'month')) {
        return `${start.format('D')} - ${end.format(`D MMM${suffix}`)}`;
    }
    if (start.isSame(end, 'year')) {
        return `${start.format('D MMM')} - ${end.format(`D MMM${suffix}`)}`;
    }
    return `${start.format(`D MMM${suffix}`)} - ${end.format(`D MMM${suffix}`)}`;
}
exports.humanRange = humanRange;
//# sourceMappingURL=timeOptions.js.map